import React, { useState } from "react";
import { useImgSrc } from "../../../hooks/uploads/useImgSrc";
import Skeleton from "@mui/material/Skeleton";
import PetsIcon from "@mui/icons-material/Pets";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export function Img({ fileId, alt = "Attachment", ...props }) {
  const { src, error } = useImgSrc(fileId);
  const [ratio, setRatio] = useState(null);

  const handleLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setRatio(naturalHeight / naturalWidth);
  };

  // Wrapper style enforces aspect ratio
  const wrapperStyle = {
    position: "relative",
    width: "100%",
    paddingTop: ratio ? `${ratio * 100}%` : "56.25%", // default 16:9 until known
  };

  if (error) {
    // Fallback avatar with aspect ratio preserved
    return (
      <div style={wrapperStyle}>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: 8,
          }}
        >
          <PetsIcon style={{ fontSize: 64, color: "#9e9e9e" }} />
        </div>
      </div>
    );
  }

  if (!src) {
    // Skeleton with aspect ratio preserved
    return (
      <div style={wrapperStyle}>
        <Skeleton
          variant="rectangular"
          animation="wave"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          {...props}
        />
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      {!ratio && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        />
      )}
      <Zoom>
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={() => console.error("Image element failed to render")}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        {...props}
      />
      </Zoom>
    </div>
  );
}
